// Components==============
import { ThemeWithProjects } from 'typings';
import { reduceFilter } from 'utilities/filters';
import { getDate } from 'utilities/getDate';
import { useRedux } from './useRedux';
// =========================

export function useThemesWithProject(filters?: any[]) {
  const user = useRedux((state) => state.authentication?.user);

  const themesWithProject = useRedux((state) => {
    const projects = state.project?.entities.allIds.map(
      (id) => state.project?.entities.byId[id]
    );

    const data = state.theme?.entities.allIds
      .map((id) => {
        const theme = state.theme?.entities.byId[id];
        const project = projects?.find(
          (p) =>
            (p?.created_by === user?.id || !!p?.in_group) &&
            p?.theme_id === parseInt(id)
        );

        const allProjects = projects?.filter(
          (p) =>
            p?.theme_id === parseInt(id) &&
            (p.created_by === user?.id ||
              (p.members &&
                p.members
                  .filter(
                    (m) =>
                      m.membership === 'teacher' || m.membership === 'extern'
                  )
                  .map((m) => m.user_id)
                  .includes(user?.id || 0)))
        );

        return { ...theme, project, allProjects };
      })
      .filter((theme) => theme?.project)
      .sort(
        (a, b) =>
          getDate(b.project?.updated_at) - getDate(a.project?.updated_at)
      );

    if (filters) return reduceFilter(filters, data);
    return data;
  }) as ThemeWithProjects[];

  return themesWithProject;
}
